export default __webpack_public_path__ + "static/media/slow.2ce39131.gif";